
export type EnrollmentCreateResponseOneOfFiveResult = typeof EnrollmentCreateResponseOneOfFiveResult[keyof typeof EnrollmentCreateResponseOneOfFiveResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateResponseOneOfFiveResult = {
  waitlisted: 'waitlisted',
} as const;
